import Model from './model.js';
import {consts as ItemConsts} from './payroll-item.js';
import Decimal from 'decimal.js';
import Log from 'lib/log';
const log = Log('newModels/item-yearly-total');

export default class ItemYearlyTotal extends Model {
    urlRoot() { return '/ItemYearlyTotals'; }

    constructor() {
        super(...arguments);
        this.softDelete = false;
    }

    initialize() {
        this.idAttribute = 'objectId';
        super.initialize(...arguments);
        this.payrollItem = this.getPayrollItem();
        this.on('change:payrollItemId', this._setPayrollItem, this);
        return this;
    }

    getPayrollItem() {
        if (this.payrollItem) {
            return this.payrollItem;
        }

        return this._setPayrollItem(this.get('payrollItemId'));
    }

    _setPayrollItem(id) {
        if (!app.payrollItems) {
            log.warn(`App hasn't any payroll items loaded`);
            return;
        }

        if (!id) {
            log.warn(`ItemYearlyTotal doesn't have a payroll item`);
            return;
        }

        this.payrollItem = app.payrollItems.find(model => {
            return model.get('objectId') === id;
        });

        return this.payrollItem;
    }

    defaults() {
        return {
            year: (new Date()).getFullYear(),
            prevEmploymentAmount: 0,
            prevEmploymentMonthly: [],
            amount: 0,
            monthly: []
        };
    }

    constraints() {
        return {
            year: {
                presence: true,
                numericality: {
                    onlyInteger: true,
                    greaterThanOrEqualTo: 0
                }
            },
            employeeId: {presence: true},
            payrollItemId: {presence: true},
            amount: {
                presence: true
            },
            prevEmploymentAmount: {
                presence: true,
            },
            additionalInformation: function(value, attrs) {
                if (!attrs.payrollItemId) {
                    return null;
                }

                if (!app.payrollItems) {
                    return null;
                }

                const payrollItem = app.payrollItems.get(attrs.payrollItemId);
                if (!payrollItem || !payrollItem.get('additionalInfoClass')) {
                    return null;
                }

                return {presence: true};
            }
        };
    }

    getPayrollItemName() {
        const item = this.getPayrollItem();
        return (item && item.get('name')) || '';
    }

    getMonthlySum(options) {
        let sum = 0;
        let monthly;

        options = _.defaults(options || {}, {
            month: 11,
            current: null
        });

        if (options.current !== true) {
            monthly = this.get('prevEmploymentMonthly') || [];

            sum = monthly.reduce(
                (acc, v) => acc.plus(v || 0),
                new Decimal(sum)
            ).toDP(2, Decimal.ROUND_HALF_UP)
            .toNumber();
        }

        if (options.current !== false) {
            monthly = this.get('monthly') || [];

            sum = monthly.reduce(
                (acc, v) => acc.plus(v || 0),
                new Decimal(sum)
            ).toDP(2, Decimal.ROUND_HALF_UP)
            .toNumber();
        }

        return sum;
    }

    isBase() {
        const item = this.getPayrollItem();
        return ((item.get('type') || null) === ItemConsts.TYPE_BASE);
    }
}



// WEBPACK FOOTER //
// ./app/new-models/item-yearly-total.js